/**
 * Number of policies by four underwriting/ re-underwriting, by place of Residence of Insured Person
 */

import { isHongKongResident } from "./helpers.js"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const header = [
	[
		"Template 07 - Number of policies by five underwriting/ re-underwriting, by place of Residence of Insured Person"
	],
	["Place of Residence", "Standard Plan", "", "", "", "Flexi Plan", "", "", ""],
	[
		"",
		"Standard Offer",
		"With Premium Loading only",
		"With CBE only",
		"With Premium Loading and CBE",
		"Standard Offer",
		"With Premium Loading only",
		"With CBE only",
		"With Premium Loading and CBE"
	]
]

const rows = payload => [
	[
		"Hong Kong",
		countStandardOffer(true, payload, "S00027"),
		countOfferWithLoadings(true, payload, "S00027"),
		countOfferWithExclusions(true, payload, "S00027"),
		countOfferWithLoadingsAndExclusions(true, payload, "S00027"),
		countStandardOffer(true, payload, "F00038"),
		countOfferWithLoadings(true, payload, "F00038"),
		countOfferWithExclusions(true, payload, "F00038"),
		countOfferWithLoadingsAndExclusions(true, payload, "F00038")
	],
	[
		"Others",
		countStandardOffer(false, payload, "S00027"),
		countOfferWithLoadings(false, payload, "S00027"),
		countOfferWithExclusions(false, payload, "S00027"),
		countOfferWithLoadingsAndExclusions(false, payload, "S00027"),
		countStandardOffer(false, payload, "F00038"),
		countOfferWithLoadings(false, payload, "F00038"),
		countOfferWithExclusions(false, payload, "F00038"),
		countOfferWithLoadingsAndExclusions(false, payload, "F00038")
	]
]

const countStandardOffer = (isPlaceOfResidence, payload, plan) => {
	return payload.filter(policy => {
		let insuredPlaceOfResidence = isHongKongResident(
			policy.contractInsured[0].addresses
		)
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredPlaceOfResidence === isPlaceOfResidence &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadings = (isPlaceOfResidence, payload, plan) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			loadings === true &&
			exclusions === false &&
			resident === isPlaceOfResidence &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const countOfferWithExclusions = (isPlaceOfResidence, payload, plan) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			exclusions === true &&
			loadings === false &&
			resident === isPlaceOfResidence &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadingsAndExclusions = (
	isPlaceOfResidence,
	payload,
	plan
) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			loadings &&
			exclusions &&
			resident === isPlaceOfResidence &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplate07Payload($policyWhere: policyWhereInput) {
			policies(where: $policyWhere) {
				list {
					status
					product {
						productId {
							plan
						}
					}
					contractInsured {
						... on individual {
							gender
							dateOfBirth
							addresses {
								id
								type
								fields2 {
									type
									value
								}
							}
						}
					}
					premium {
						loadings {
							id
						}
					}
					exclusions {
						id
					}
				}
			}
		}
	`
	const variables = {
		policyWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.policies?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 4 }
		},
		{
			s: { r: 1, c: 5 },
			e: { r: 1, c: 8 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
